import { http } from '@/utils/request'
import type { ApiResponse } from '@/types/api'

export interface ContactFormData {
  name: string
  company?: string
  email: string
  phone?: string
  subject?: string
  category: string
  message: string
  ipAddress?: string
  userAgent?: string
  status?: string
}

export interface ContactSubmitResponse {
  code: number
  msg: string
  data: any
}

// 联系表单相关 API
export const contactApi = {
  // 提交联系表单
  submitContactForm: (data: ContactFormData) =>
    http.post<ContactSubmitResponse>('/submissions/submit', data),
}